var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"interactions",class:{
    'is-expanded': _vm.isExpanded,
    'is-fullscreen': _vm.isFullscreen,
    'is-scrolled': _vm.$store.state.coreData.scrollState === 'scrolled',
    'is-preview': !_vm.$store.state.coreData.isEditing,
  }},[(_vm.$attrs.isEditing)?_c('div',{staticClass:"down-trigger"},[_c('ArrowButton',{class:{'black': _vm.isDesktop && !_vm.isExpanded},attrs:{"direction":"down","is-shown":true,"onClick":_vm.toggle}})],1):_vm._e(),_c('div',{staticClass:"interactions-options"},[_vm._t("default",null,{"toggle":_vm.toggle,"isExpanded":_vm.isExpanded})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }